import { __assign } from "tslib";
import * as React from 'react';
import { MultiInput } from './multi-input';
import { KeyCode } from '../../common/key-codes.enum';
import { renderAndMountComponent } from '@wix/answers-lib';
import { getLegacyBaseDriverFromWrapper, simulateBlur } from '../../common/base-driver';
export var createMultiInputDriver = function (wrapper) {
    var base = getLegacyBaseDriverFromWrapper(wrapper, '.multi-input', MultiInput.name);
    return {
        getTags: function () { return base.findAll('.react-tagsinput-tag').getText().map(function (tag) { return tag.trim(); }); },
        addTag: function (tag) {
            var input = base.find('input');
            input.enterValue(tag);
            input.pressKey(KeyCode.ENTER);
        },
        blur: function () {
            var input = base.find('input');
            simulateBlur(input.elem);
        },
        isTagRejected: function () { return !!base.isChildVisible('.is-rejected'); },
        isErrorMsgVisible: function () { return !!base.isChildVisible('.invalid-msg'); },
        isDisabled: function () { return !!base.hasClass('disabled'); },
        isMaxTagsDisabled: function () { return !!base.find('.multi-input-wrapper').hasClass('max-tags-disabled'); },
    };
};
export var renderMultiInputAndReturnDriver = function (props) {
    var elem = renderAndMountComponent(React.createElement(MultiInput, __assign({}, props)));
    return createMultiInputDriver(elem);
};
//# sourceMappingURL=multi-input.driver.js.map